import React from 'react'
import { List } from 'gu-ui-kit'
import EmptyResults from 'components/EmptyResults'
import { useTableConfig } from 'modules/Referral/ReferralLinks/subcomponents/Table/hooks/useTableConfig'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ReactComponent as EmptyResultsSVG } from 'images/illustration/no-referral-links.svg'

export const Table = ({ data, handleChangeName }) => {
  const { t } = useTranslation()

  const { tableState, tableConfig } = useTableConfig(
    {
      handleChangeName,
    },
    data,
  )

  return (
    <List
      table={tableState}
      config={tableConfig}
      EmptyComponent={() => (
        <EmptyResults
          header={t('referral::referral_links.table.empty_list.heading')}
          text={t('referral::referral_links.table.empty_list.summary')}
          image={<EmptyResultsSVG />}
        />
      )}
    />
  )
}

Table.propTypes = {
  data: PropTypes.array,
  handleChangeName: PropTypes.func,
}
